import { useEffect, useRef, useState } from 'react';

import _ from 'lodash';
import ReactDOM from 'react-dom';

import { ENUM_QUESTION_TYPE } from 'constants/enum';
import { CATEGORY_VIDEOS_ASE, VIDEO_TUTORIAL } from 'constants/index';
import { TEXT_RESULT_REPORT } from 'constants/string/texts';
import RadioCheckbox from 'pages/Survey/Form/_components/question/RadioCheckbox';

import VideoPlayer from './VideoPlayer';

const Arrow = require('assets/resources/Arrow.svg').default;
const ArrowCircleDark = require('assets/resources/ArrowCircleDark.svg').default;
const CloseCircleDark = require('assets/resources/CloseCircleDark.svg').default;

const VideoCategory = (props) => {
  const { data } = props;

  const [isShowTutorial, setIsShowTutorial] = useState(true);
  const [heightTutorial, setHeightTutorial] = useState(0);
  const tutorialRef = useRef(null);

  const [isShowCheckpoints, setIsShowCheckpoints] = useState(true);
  const [dataCheckpoints, setDataCheckpoints] = useState([]);
  const [heightCheckpoints, setHeightCheckpoints] = useState(0);
  const checkpointsRef = useRef(null);

  const videoTutorialKey = Object.keys(VIDEO_TUTORIAL);
  const indexVideoTutorial = videoTutorialKey.findIndex((item) => item === data.title);

  const videoCategoryKey = Object.keys(CATEGORY_VIDEOS_ASE);
  const indexVideoCategory = videoCategoryKey.findIndex((item) => item === data.title);

  useEffect(() => {
    if (tutorialRef.current) {
      setHeightTutorial(tutorialRef.current.scrollHeight);
    }
  }, [tutorialRef.current]);

  useEffect(() => {
    if (checkpointsRef.current) {
      setHeightCheckpoints(checkpointsRef.current.scrollHeight);
    }
  }, [checkpointsRef.current]);

  const handleCheckpoints = () => {
    if (data.video_category && data.video_category.checkpoints && data.video_category.checkpoints.length > 0) {
      const dataCheckpoints = {
        question_type: ENUM_QUESTION_TYPE.CHECKBOX,
        options: data.video_category?.checkpoints?.map((item) => ({
          option_text: item?.description,
          id: item?.id,
        })),
        answer: _.filter(data.video_category?.checkpoints, { status: true })?.map((item) => item.id),
      };
      setDataCheckpoints(dataCheckpoints);
    } else {
      const dataCheckpoints = {
        question_type: ENUM_QUESTION_TYPE.CHECKBOX,
        options: CATEGORY_VIDEOS_ASE[videoCategoryKey[indexVideoCategory]]?.map((item, index) => ({
          option_text: item,
          id: index,
        })),
        answer: [],
      };
      setDataCheckpoints(dataCheckpoints);
    }
  };

  useEffect(() => {
    handleCheckpoints();
  }, [data.video_category]);

  if (indexVideoTutorial === -1 && indexVideoCategory === -1) {
    return <></>;
  }

  return (
    <div className="flex flex-col justify-between gap-2 ml-2">
      <div className="w-full bg-white rounded overflow-hidden">
        {indexVideoTutorial !== -1 && (
          <>
            <div className="py-3 px-6 border-b border-solid border-black/10 flex justify-between items-center">
              <p className="font-bold text-black/85">{TEXT_RESULT_REPORT.VIDEO_TUTORIAL}</p>
              <img
                src={Arrow}
                alt="image"
                width={16}
                height={16}
                className={`cursor-pointer ${isShowTutorial ? 'rotate-180' : ''}`}
                onClick={() => setIsShowTutorial(!isShowTutorial)}
              />
            </div>
            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${!isShowTutorial ? '!max-h-0' : ''}`}
              style={{ maxHeight: heightTutorial === 0 ? 'auto' : heightTutorial }}
              ref={tutorialRef}
            >
              <ul className="py-4 px-6">
                {VIDEO_TUTORIAL[videoTutorialKey[indexVideoTutorial]]?.map((item, index) => (
                  <li key={`video-${index}`} className="text-black-102">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </div>
      <div className="w-full bg-white rounded overflow-hidden">
        {indexVideoCategory !== -1 && (
          <>
            <div className="py-3 px-6 border-b border-solid border-black/10 flex justify-between items-center">
              <p className="font-bold text-black/85">{TEXT_RESULT_REPORT.VIDEO_CATEGORY}</p>
              <img
                src={Arrow}
                alt="image"
                width={16}
                height={16}
                className={`cursor-pointer ${isShowCheckpoints ? 'rotate-180' : ''}`}
                onClick={() => setIsShowCheckpoints(!isShowCheckpoints)}
              />
            </div>
            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${!isShowCheckpoints ? '!max-h-0' : ''}`}
              style={{ maxHeight: heightCheckpoints === 0 ? 'auto' : heightCheckpoints }}
              ref={checkpointsRef}
            >
              <div className="py-4 px-6">
                <RadioCheckbox data={dataCheckpoints} isPreview={false} viewOnly={true} />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const VideoPreview = (props) => {
  const { media_files, data, close, firstOpen } = props;
  const [currentIndex, setCurrentIndex] = useState(firstOpen);
  const [isShowAnswer, setIsShowAnswer] = useState(true);

  useEffect(() => {
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('h-screen');

    return () => {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('h-screen');
    };
  }, []);

  const onPrev = () => {
    if (currentIndex === 0) {
      setCurrentIndex(media_files.length - 1);
    } else {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const onNext = () => {
    if (currentIndex === media_files.length - 1) {
      setCurrentIndex(0);
    } else {
      setCurrentIndex(currentIndex + 1);
    }
  };

  return ReactDOM.createPortal(
    <div data-testid="modal" id="modal" className="fixed inset-0 flex-middle-center z-max bg-black bg-opacity-50 ">
      <div className="relative w-full h-full flex justify-center items-center">
        <div className="absolute top-8 right-10 w-16 h-16 cursor-pointer" onClick={close}>
          <img src={CloseCircleDark} alt="image" width={64} height={64} />
        </div>
        <div className="flex justify-center items-center space-x-10">
          {media_files.length > 1 && <img src={ArrowCircleDark} alt="image" width={64} height={64} className="cursor-pointer" onClick={onPrev} />}

          <div className="flex">
            <div>
              <div className="w-320 h-167.5 flex overflow-hidden">
                {media_files.map((item, index) => (
                  <div
                    key={`video-${index}`}
                    className="min-w-320 w-320 h-167.5 flex justify-center items-center transition-transform duration-300 ease-in-out relative"
                    style={{ transform: `translateX(-${currentIndex * 1280}px)` }}
                  >
                    {currentIndex === index ? <VideoPlayer item={item} /> : <></>}
                  </div>
                ))}
              </div>
              {data.answer && data.answer.length > 0 && (
                <div className="pt-4">
                  <div className="max-h-80 w-320 rounded bg-white overflow-hidden">
                    <div className="px-6 py-3 border-b border-solid border-black/10 flex justify-between items-center">
                      <p className="font-bold text-black/85">{TEXT_RESULT_REPORT.ADDITIONAL_CONTENT}</p>
                      <img
                        src={Arrow}
                        alt="image"
                        width={16}
                        height={16}
                        className={`cursor-pointer ${isShowAnswer ? 'rotate-180' : ''}`}
                        onClick={() => setIsShowAnswer(!isShowAnswer)}
                      />
                    </div>
                    <div className={`overflow-hidden max-h-68 transition-all duration-300 ease-in-out ${!isShowAnswer ? '!max-h-0' : ''}`}>
                      <div className="px-3 py-4">
                        <div className="px-3 max-h-60 overflow-auto" dangerouslySetInnerHTML={{ __html: data.answer.replace(/\n/g, '<br />') }}></div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="max-w-118 max-h-213.5 overflow-y-auto">
              <VideoCategory data={data} />
            </div>
          </div>
          {media_files.length > 1 && (
            <img src={ArrowCircleDark} className="rotate-180 cursor-pointer" alt="image" width={64} height={64} onClick={onNext} />
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default VideoPreview;
